export const tradeByClientsLocation = "/reports/exchbusiness/turnoverclients";
